export var EAlertHandlingSortByField;
(function (EAlertHandlingSortByField) {
    EAlertHandlingSortByField["SHOW"] = "showAt";
    EAlertHandlingSortByField["CREATED"] = "createdAt";
    EAlertHandlingSortByField["MODIFIED"] = "updatedAt";
    // Dev note! Only numeric fields supported so far by the search() of the AlertHandlingEntity.
})(EAlertHandlingSortByField || (EAlertHandlingSortByField = {}));
